




























import Vue from 'vue'
import { Datetime } from 'vue-datetime'
import moment from 'moment-timezone'
import Tenant from '@/types/Tenant.interface'
export default Vue.extend({
    components: { Datetime },
    props: {
        //  The day of the week that is being handled by the component
        day: {
            type: Object,
            required: true
        },
        //  The label/title of the line
        label: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            //  The form's validation errors
            vErrors: {},
            //  The date format used by the datetime picker
            format: 't'
        }
    },
    mounted() {
        this.validate()
    },
    computed: {
        dayClose: {
            get(): string {
                //  If the value does NOT exist, return nothing
                if (!this.day.close) return null

                //  Parse the simple 'hour:minute' into datetime string
                const datetime = moment(this.day.close, 'HH:mm').format('Y-MM-DD HH:mm')

                //  Attach the tenant's default timezone
                const scoped = moment.tz(datetime, this.tenant.default_timezone)

                //  Return the tenant scoped
                return scoped.format()
            },
            set(val: Date): void {
                //  If the value does NOT exist, set the day to nothing
                if (!val) return (this.day.close = null)

                //  Parse the full datetime into simple 'hour:minute' format
                const parsed = moment(val)
                    .tz(this.tenant.default_timezone)
                    .format('HH:mm')

                //  Set the day's 'hour:minute' time
                this.day.close = parsed
            }
        },
        dayOpen: {
            get(): string {
                if (!this.day.open) return null

                //  Parse the simple 'hour:minute' into datetime string
                const datetime = moment(this.day.open, 'HH:mm').format('Y-MM-DD HH:mm')

                //  Attach the tenant's default timezone
                const scoped = moment.tz(datetime, this.tenant.default_timezone)

                //  Return the tenant scoped
                return scoped.format()
            },
            set(val: Date): void {
                if (!val) return (this.day.open = null)

                //  Parse the full datetime into simple 'hour:minute' format
                const parsed = moment(val)
                    .tz(this.tenant.default_timezone)
                    .format('HH:mm')

                //  Set the day's 'hour:minute' time
                this.day.open = parsed
            }
        },
        errorMessage(): string {
            //  Check for an error on the 'open' field
            const openError = this.vErrors.open

            //  If the error exists, return it
            if (openError) return openError

            //  Check for an error on the 'close' field
            const closeError = this.vErrors.close

            //  If the error exists, return it
            if (closeError) return closeError

            //  Else, return null
            return null
        },
        dayStatus(): string {
            //  If the day is NOT active, return 'closed'
            if (!this.day.active) return '<span class="red--text">Closed</span>'

            //  Else, check if a any specific times are set
            const hasTimes = this.day.open || this.day.close

            //  If the day has specific times, return 'open'
            if (hasTimes) return 'Open'

            //  Else, return 'All Day'
            return 'All Day'
        },
        tenant(): Tenant {
            return this.$store.getters.tenant
        }
    },
    methods: {
        onActiveChanged(): void {
            //  If the user has toggled the 'active' property, we reset open/close
            this.day.open = null
            this.day.close = null
        },
        validate() {
            this.vErrors = {}

            //  Check if the day is closed all day
            const closedAllDay = this.day.active === false

            //  If the day is closed all day, remove errors
            if (closedAllDay) return (this.vErrors = {})

            //  Check if the data i open all day
            const openAllDay = this.day.active && !this.day.open && !this.day.close

            //   If the data open all day, remove errors
            if (openAllDay) return (this.vErrors = {})

            //   Check if 'open' is a valid date
            const validOpen = moment(this.dayOpen).isValid()

            //  If 'open' is NOT valid, show error
            if (!validOpen) return (this.vErrors.open = `Please set a valid 'Open' time`)

            //  Check if 'close' is a valid date
            const validClose = moment(this.dayClose).isValid()

            //  If 'close' is NOT valid, show error
            if (!validClose)
                return (this.vErrors.close = `Please set a valid 'Close' time`)

            //  Check if the close time is AFTER the open time
            const isAfter = moment(this.dayClose).isAfter(this.dayOpen)

            //  If the 'close' time is NOT after the 'open' time, show error
            if (!isAfter)
                return (this.vErrors.close = `Please set 'Close' time later than 'Open' time`)
        }
    },
    watch: {
        day: {
            deep: true,
            handler(): void {
                this.validate()
            }
        }
    }
})
